import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ChatSoundState {
  soundEnabled: boolean
  toggleSound: () => void
  setSoundEnabled: (enabled: boolean) => void
}

// Audio instance for notification sound
let notificationAudio: HTMLAudioElement | null = null

// Initialize audio on first use
const getAudio = () => {
  if (!notificationAudio && typeof window !== 'undefined') {
    notificationAudio = new Audio('/ring-medhunter.mp3')
    notificationAudio.volume = 0.5
  }
  return notificationAudio
}

export const useChatSoundStore = create<ChatSoundState>()(
  persist(
    (set) => ({
      soundEnabled: true,
      toggleSound: () => set((state) => ({ soundEnabled: !state.soundEnabled })),
      setSoundEnabled: (enabled) => set({ soundEnabled: enabled }),
    }),
    {
      name: 'medhunter-chat-sound',
    }
  )
)

// Play notification sound
export const playNotificationSound = () => {
  const { soundEnabled } = useChatSoundStore.getState()
  if (!soundEnabled) return

  const audio = getAudio()
  if (audio) {
    audio.currentTime = 0
    audio.play().catch(() => {
      // Ignore autoplay errors (browser policy)
    })
  }
}
